var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgIn(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 5h20v14H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.335c1.314 0 2.381-1.046 2.381-2.334s-1.067-2.333-2.38-2.333c-1.315 0-2.382 1.045-2.382 2.333 0 1.288 1.067 2.334 2.381 2.334zm0-.934c.789 0 1.429-.627 1.429-1.4 0-.772-.64-1.4-1.429-1.4s-1.428.627-1.428 1.4c0 .773.64 1.4 1.428 1.4z",
    fill: "#1A47B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.469a.471.471 0 00.476-.467.471.471 0 00-.476-.467.471.471 0 00-.476.467c0 .258.213.466.476.466z",
    fill: "#1A47B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14.332h20v4.667H2v-4.667z",
    fill: "#249F58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5h20v4.667H2V5z",
    fill: "#FF6C2D"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 5)",
    d: "M0 0h20v14H0z"
  })))));
}
export default SvgIn;